import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';

/**
 * Manage the state of modals and overlays
 */

var OPEN = 'store/modal/OPEN';
var CLOSE = 'store/modal/CLOSE';
var CLOSE_ALL = 'store/modal/CLOSE_ALL';
var FORCE_OPEN = 'store/modal/FORCE_OPEN';
var TOGGLE = 'store/modal/TOGGLE';

var stateOpen = function stateOpen() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var modal = arguments[1];
  return state.indexOf(modal) === -1 ? [].concat(_toConsumableArray(state), [modal]) : state;
};

var stateOnlyOpen = function stateOnlyOpen(_state, modal) {
  return [modal];
};

var stateClose = function stateClose() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var modal = arguments[1];
  return state.indexOf(modal) >= 0 ? state.filter(function (m) {
    return m !== modal;
  }) : state;
};

var stateCloseAll = function stateCloseAll() {
  return [];
};

var stateToggle = function stateToggle() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var modal = arguments[1];
  return state.indexOf(modal) >= 0 ? state.filter(function (m) {
    return m !== modal;
  }) : [modal];
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case OPEN:
      return stateOpen(state, action.modal);

    case FORCE_OPEN:
      return stateOnlyOpen(state, action.modal);

    case CLOSE:
      return stateClose(state, action.modal);

    case CLOSE_ALL:
      return stateCloseAll(state);

    case TOGGLE:
      return stateToggle(state, action.modal);

    default:
      return state;
  }
}

var open = function open(modal) {
  return {
    type: OPEN,
    modal: modal
  };
};

var forceOpen = function forceOpen(modal) {
  return {
    type: FORCE_OPEN,
    modal: modal
  };
};

var close = function close(modal) {
  return {
    type: CLOSE,
    modal: modal
  };
};

/**
 * Toggles the given modal, if an other modal is open and the requested modal is not,  it will be closed.
 */
var toggle = function toggle(modal) {
  return {
    type: TOGGLE,
    modal: modal
  };
};

var closeAll = function closeAll() {
  return {
    type: CLOSE_ALL
  };
};

export { OPEN, CLOSE, CLOSE_ALL, FORCE_OPEN, TOGGLE, stateOpen, stateOnlyOpen, stateClose, stateCloseAll, stateToggle, open, forceOpen, close, toggle, closeAll };
export default reducer;
